import { LocalizationProvider, TabContext, TabList, TabPanel } from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import {
  Badge,
  Box,
  Button,
  Card,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Tab,
  TextField,
  Typography,
} from "@mui/material";
import { useState } from "react";
import BookingInformation from "./BookingInformation";
import api from "../../../../components/services/api";
import { useEffect } from "react";
import { useParams } from "react-router";
import Transportion from "./Transportion";
import AttachFile from "./AttachFile";
import TagError from "./TagError";
import Container from "./Container";
import LogStatus from "./LogStatus";
import Docment from "./Docment";
import ExtraExpense from "./ExtraExpense";
import Cost from "./Cost";
import Advanpayment from "./Advanpayment";
import Swal from "sweetalert2";
export default function EditSaleOrder() {
  let { id } = useParams();
  const data_params = { id: id };
  const [statusSelect_data, setStatusSelect_data] = useState("");
  const [saleOrderData, setSaleOrderData] = useState([]);
  const [saleOrderNo, setSaleOrderNo] = useState();
  const [statusSO_data, setStatusSo_data] = useState([]);
  // const [voy_no_select, setVoySelect] = useState([]);
  const [value, setValue] = useState("1");
  const handleChangeTab = (event, newValue) => {
    setValue(newValue);
  };
  const changeStatus = async () => {
    const body = {
      SaleOrderId: id,
      SaleOrderStatus: statusSelect_data,
    };
    const res = await api.post("/api/saleorder/update/status", body);
    if (res.meta.status) {
      Swal.fire({
        title: `${res.meta.message}`,
        icon: "success",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "OK",
      }).then((result) => {
        if (result.isConfirmed) {
        }
      });
    }
  };

  const FetchStatusSo = async () => {
    try {
      const res = await api.get("api/master/saleorder/status");

      setStatusSo_data(res.data);
    } catch (e) {
      console.log(e);
    }
  };
  useEffect(() => {
    FetchStatusSo();
  }, []);
  const handleClose = async () => {
    const res = await api.get(`api/saleorder/cancel/${id}`);
    if (res.meta.status) {
      Swal.fire("Confirm!", "", "success");
      window.location.reload();
    }
  };
  const handleCancelCancel = async () => {
    const res = await api.get(`api/saleorder/cancel-cancel/${id}`);
    if (res.meta.status) {
      Swal.fire("Confirm!", "", "success");
      window.location.reload();
    }
  };
  console.log(statusSelect_data);
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Card variant="outlined" style={{ padding: "20px", margin: "25px" }}>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Grid container alignItems="center" spacing={1}>
            <Grid item xs>
              <Typography
                className="textcolordarkblue"
                variant="h5"
                component="h1"
              >
                Sale Order
              </Typography>
              <Typography className="textcolorgreen">#{saleOrderNo}</Typography>
            </Grid>
          </Grid>

          <Box>
            <Box sx={{ display: "flex", marginBottom: "10px" }}>
              <Typography className="textcolorBule" style={{whiteSpace:"nowrap"}}>
                Customer Support / Sale Order
              </Typography>
              <Typography style={{whiteSpace:"nowrap"}}>
                <span>&nbsp;</span> / Detail
              </Typography>
            </Box>

            <Box sx={{ display: "flex" }}>
              {statusSelect_data !== 0 ? (
                <>
                  <FormControl style={{ width: "250px" }}>
                    <InputLabel id="demo-simple-select-label">สถานะ</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={statusSelect_data}
                      label="สถานะ"
                      onChange={(e) => {
                        setStatusSelect_data(e.target.value);
                      }}
                    >
                      <MenuItem value="" disabled>
                        <em>เลือก สถานะ SaleOrder</em>
                      </MenuItem>

                      {statusSO_data.map((option, index) => {
                        return (
                          <MenuItem key={index} value={option.TypeSaleOrderId}>
                            {option.TypeName}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                  <Button
                    variant="contained"
                    onClick={changeStatus}
                    color="warning"
                    sx={{ m: "5px" }}
                  >
                    อัพเดท
                  </Button>
                  <Button
                    variant="contained"
                    onClick={() => {
                      Swal.fire({
                        icon: "question",
                        title: "Want to cancel?",
                        showCancelButton: true,
                        confirmButtonText: "confirm",
                      }).then((result) => {
                        /* Read more about isConfirmed, isDenied below */
                        if (result.isConfirmed) {
                          handleClose();
                        }
                      });
                    }}
                    color="error"
                    sx={{ m: "5px" }}
                  >
                    ยกเลิก
                  </Button>
                </>
              ) : (
                <>
                  <TextField
                    label="สถานะ"
                    variant="outlined"
                    placeholder="สถานะ"
                    disabled
                    value={statusSelect_data === 0 ? 'ยกเลิก' : ''}
                    // onChange={(e) => setFieldValue('ConfirmSITime', moment(e).format('yyyy-MM-DD'))}
                    style={{ width: "100%", marginRight: 5 }}
                    InputLabelProps={{ shrink: true }}
                  />
                  <Button
                    variant="contained"
                    onClick={() => {
                      Swal.fire({
                        icon: "question",
                        title: "Want to cancel?",
                        showCancelButton: true,
                        confirmButtonText: "confirm",
                      }).then((result) => {
                        /* Read more about isConfirmed, isDenied below */
                        if (result.isConfirmed) {
                          handleCancelCancel();
                        }
                      });
                    }}
                    color="error"
                    sx={{ m: "5px" }}
                  >
                    ยกเลิก
                  </Button>
                </>
              )}
            </Box>
          </Box>
        </div>

        <TabContext value={value}>
          <Box
            sx={{
              borderBottom: 1,
              borderColor: "divider",
              marginTop: "10px",
            }}
          >
            <TabList
              variant="scrollable"
              scrollButtons="auto"
              onChange={handleChangeTab}
              TabIndicatorProps={{
                style: { backgroundColor: "transparent" },
              }}
              sx={{
                overflow: "visible",
                "& .MuiTabs-scroller": { overflow: "visible !important" },
              }}
            >
              <Tab
                sx={{
                  "&.Mui-selected": {
                    background: "#80C340",
                    color: "white",
                    borderTopLeftRadius: "15px",
                    borderTopRightRadius: "15px",
                  },
                  overflow: "visible",
                  "& .MuiTabs-scroller": { overflow: "visible !important" },
                }}
                label={
                  // <Badge badgeContent={4} color="error" sx={{ "& .MuiBadge-badge": { top: '-10px' } }}>
                  // <Typography>BOOKING INFORMATION</Typography>
                  // </Badge>
                  "BOOKING INFORMATION"
                }
                value="1"
              />

              <Tab
                sx={{
                  "&.Mui-selected": {
                    background: "#80C340",
                    color: "white",
                    borderTopLeftRadius: "15px",
                    borderTopRightRadius: "15px",
                  },
                }}
                label="TRANSPORTATION"
                value="2"
              />
              <Tab
                sx={{
                  "&.Mui-selected": {
                    background: "#80C340",
                    color: "white",
                    borderTopLeftRadius: "15px",
                    borderTopRightRadius: "15px",
                  },
                }}
                label="CONTAINER"
                value="3"
              />
              <Tab
                sx={{
                  "&.Mui-selected": {
                    background: "#80C340",
                    color: "white",
                    borderTopLeftRadius: "15px",
                    borderTopRightRadius: "15px",
                  },
                }}
                label="DOCUMENT"
                value="4"
              />

              <Tab
                sx={{
                  "&.Mui-selected": {
                    background: "#80C340",
                    color: "white",
                    borderTopLeftRadius: "15px",
                    borderTopRightRadius: "15px",
                  },
                }}
                label="EXTRA EXPENSE"
                value="5"
              />
              <Tab
                sx={{
                  "&.Mui-selected": {
                    background: "#80C340",
                    color: "white",
                    borderTopLeftRadius: "15px",
                    borderTopRightRadius: "15px",
                  },
                }}
                label="ADVANCE PAYMENT"
                value="6"
              />
              <Tab
                sx={{
                  "&.Mui-selected": {
                    background: "#80C340",
                    color: "white",
                    borderTopLeftRadius: "15px",
                    borderTopRightRadius: "15px",
                  },
                }}
                label="Cost"
                value="10"
              />
              <Tab
                sx={{
                  "&.Mui-selected": {
                    background: "#80C340",
                    color: "white",
                    borderTopLeftRadius: "15px",
                    borderTopRightRadius: "15px",
                  },
                }}
                label="TAG ERROR"
                value="7"
              />
              <Tab
                sx={{
                  "&.Mui-selected": {
                    background: "#80C340",
                    color: "white",
                    borderTopLeftRadius: "15px",
                    borderTopRightRadius: "15px",
                  },
                }}
                label="ATTACHFILE"
                value="8"
              />
              <Tab
                sx={{
                  "&.Mui-selected": {
                    background: "#80C340",
                    color: "white",
                    borderTopLeftRadius: "15px",
                    borderTopRightRadius: "15px",
                  },
                }}
                label="LOG STATUS"
                value="9"
              />
            </TabList>
          </Box>
          <TabPanel value="1">
            <BookingInformation
              saleOrderData={saleOrderData}
              id={id}
              setSaleOrderNo={setSaleOrderNo}
              setStatusSelect_data={setStatusSelect_data}
            />
          </TabPanel>
          <TabPanel value="2">
            <Transportion saleOrderData={saleOrderData} setValue={setValue} />
          </TabPanel>
          <TabPanel value="3">
            <Container saleOrderData={saleOrderData} setValue={setValue} />
          </TabPanel>
          <TabPanel value="4">
            <Docment />
          </TabPanel>
          <TabPanel value="5">
            <ExtraExpense setValue={setValue} />
          </TabPanel>
          <TabPanel value="6">
            <Advanpayment setValue={setValue} />
          </TabPanel>
          <TabPanel value="10">
            <Cost setValue={setValue} id={data_params} />
          </TabPanel>
          <TabPanel value="7">
            <TagError SaleorderData={saleOrderData} setValue={setValue} />
          </TabPanel>
          <TabPanel value="8">
            <AttachFile SaleorderData={saleOrderData} setValue={setValue} />
          </TabPanel>
          <TabPanel value="9">
            <LogStatus id={data_params} setValue={setValue} />
          </TabPanel>
        </TabContext>
      </Card>
    </LocalizationProvider>
  );
}
